import React, { useContext, useEffect, useState } from 'react';

import { MapContext } from '../../component';
import mapboxgl, { FitBoundsOptions } from 'mapbox-gl';

export const GeolocateControl = ({
  position,
  options = {
    positionOptions: { enableHighAccuracy: false, timeout: 6000 },
    fitBoundsOptions: { maxZoom: 15 },
    trackUserLocation: true,
    showAccuracyCircle: true,
    showUserLocation: true,
  },
  getControl,
}: {
  position?: controlPositions;
  options?: {
    positionOptions?: PositionOptions;
    fitBoundsOptions?: FitBoundsOptions;
    trackUserLocation?: boolean;
    showAccuracyCircle?: boolean;
    showUserLocation?: boolean;
  };
  getControl?: (a: mapboxgl.GeolocateControl) => void;
}) => {
  const map = useContext(MapContext);
  const [control, setControl] = useState(null);

  useEffect(() => {
    if (control) map.removeControl(control);
    const newcontrol: mapboxgl.GeolocateControl = new mapboxgl.GeolocateControl(
      options
    );
    map.addControl(newcontrol, position);

    if (getControl) getControl(newcontrol);

    setControl(newcontrol);
  }, []);
  return null;
};
